import { createWebHistory,createRouter } from "vue-router";
import Home from '../pages/Home.vue';
// import HomeTwo from '../pages/HomeTwo.vue';
// import HomeThree from '../pages/HomeThree.vue';
// import Courses from '../pages/Courses.vue';
// import CoursesList from '../pages/CoursesList.vue';
// import CourseSidebar from '../pages/CourseSidebar.vue';
// import CourseDetails from '../pages/CourseDetails.vue';
// import Blog from '../pages/Blog.vue';
// import BlogDetails from '../pages/BlogDetails.vue';
import About from '../pages/About.vue';
// import Instructor from '../pages/Instructor.vue';
// import InstructorDetails from '../pages/InstructorDetails.vue';
// import EventDetails from '../pages/EventDetails.vue';
// import Cart from '../pages/Cart.vue';
// import Checkout from '../pages/Checkout.vue';
// import SignIn from '../pages/SignIn.vue';
// import SignUp from '../pages/SignUp.vue';
// import ErrorPage from '../pages/ErrorPage.vue';
import Contact from '../pages/Contact.vue';
// import CourseDetailsPage from '../pages/DynamicCourseDetails.vue';
import DynamicBlogDetails from '../pages/DynamicBlogDetails.vue';

const router = createRouter({
    history: createWebHistory(),
    routes:[
        {
            path:'/',
            name: 'Home',
            component:Home,
            meta: {
                title: 'Ana Sayfa - GelişimP Türkiye'
            }
        },
        {
            path:'/home',
            name: 'HomePage',
            component:Home,
            meta: {
                title: 'Ana Sayfa - GelişimP Türkiye'
            }
        },
        // {
        //     path:'/home-two',
        //     component:HomeTwo,
        // },
        // {
        //     path:'/home-three',
        //     component:HomeThree,
        // },
        // {
        //     path:'/courses',
        //     component:Courses,
        // },
        // {
        //     path:'/courses-list',
        //     component:CoursesList,
        // },
        // {
        //     path:'/courses-sidebar',
        //     component:CourseSidebar,
        // },
        // {
        //     path:'/course-details',
        //     component:CourseDetails,
        // },
        // {
        //     path:'/blog',
        //     name: 'Blog',
        //     component:Blog,
        // },
        // {
        //     path:'/blog-details',
        //     name: 'BlogDetails',
        //     component:BlogDetails,
        // },
        {
            path:'/about',
            name: 'About',
            component:About,
            meta: {
                title: 'Hakkımızda - GelişimP Türkiye'
            }
        },
        // {
        //     path:'/instructor',
        //     component:Instructor,
        // },
        // {
        //     path:'/instructor-details',
        //     component:InstructorDetails,
        // },
        // {
        //     path:'/event-details',
        //     component:EventDetails,
        // },
        // {
        //     path:'/cart',
        //     component:Cart,
        // },
        // {
        //     path:'/checkout',
        //     component:Checkout,
        // },
        // {
        //     path:'/login',
        //     component:SignIn,
        // },
        // {
        //     path:'/register',
        //     component:SignUp,
        // },
        // {
        //     path:'/errorPage',
        //     component:ErrorPage,
        // },
        {
            path:'/contact',
            name: 'Contact',
            component:Contact,
            meta: {
                title: 'İletişim - GelişimP Türkiye'
            }
        },
        // {
        //     path:'/course-details/:id',
        //     component:CourseDetailsPage,
        // },
        {
            path:'/blog-details/:slug',
            name: 'DynamicBlogDetails',
            component:DynamicBlogDetails,
            meta: {
                title: 'Blog Detay - GelişimP Türkiye'
            }
        },
        {
            path: '/admin',
            name: 'Admin',
            component: () => import('../pages/admin/AdminDashboard.vue'),
            meta: {
                title: 'Admin - GelişimP Türkiye'
            },
            children: [
                {
                    path: 'courses',
                    name: 'AdminCourses',
                    component: () => import('../pages/admin/AdminCourses.vue'),
                    meta: {
                        title: 'Kurslar Yönetimi - GelişimP Türkiye'
                    }
                },
                {
                    path: 'events',
                    name: 'AdminEvents',
                    component: () => import('../pages/admin/AdminEvents.vue'),
                    meta: {
                        title: 'Seminerler Yönetimi - GelişimP Türkiye'
                    }
                },
                {
                    path: 'blog',
                    name: 'AdminBlog',
                    component: () => import('../pages/admin/AdminBlog.vue'),
                    meta: {
                        title: 'Blog Yazıları Yönetimi - GelişimP Türkiye'
                    }
                }
            ]
        },
        // Tanımlı olmayan tüm URL'leri ana sayfaya yönlendir
        {
            path: '/:pathMatch(.*)*',
            redirect: '/',
            meta: {
                title: 'GelişimP Türkiye'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    // Sayfa başlığını güncelle
    document.title = to.meta.title || 'GelişimP Türkiye'
    next()
    window.scrollTo(0, 0)
});

export default router